import { render, staticRenderFns } from "./message-input-editor.vue?vue&type=template&id=1f06e095&scoped=true"
import script from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-input-editor.vue?vue&type=style&index=0&id=1f06e095&prod&scoped=true&lang=scss"
import style1 from "./message-input-editor.vue?vue&type=style&index=1&id=1f06e095&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06e095",
  null
  
)

export default component.exports